<template>
  <div class="comp-md-file-tree">
    <el-tree
            lazy
            v-if="lazy"
            :load="load"
            node-key="id"
            highlight-current
            @node-click="handelFile"
            :props="{ label: 'name', children: 'children', isLeaf: 'fileSuffix' }">
      <span class="custom-tree-node" slot-scope="{ node, data }">
        <span>
          <svg class="icon" aria-hidden="true">
            <use :xlink:href="'#' + (data.folder ? 'icon-folder' : (fileIcon[data.fileSuffix] ? fileIcon[data.fileSuffix] : 'icon-unknowndoc'))"></use>
          </svg>
          {{ node.label }}
        </span>
      </span>
    </el-tree>
    <el-tree
            :data="getThreeData"
            v-else
            node-key="id"
            highlight-current
            @node-click="handelFile"
            :props="{ label: 'name', children: 'children' }">
      <span class="custom-tree-node" slot-scope="{ node, data }">
        <span>
          <svg class="icon" aria-hidden="true">
            <use :xlink:href="'#' + (fileIcon[data.fileSuffix] ? fileIcon[data.fileSuffix] : 'icon-unknowndoc')"></use>
          </svg>
          {{ node.label }}
        </span>
      </span>
    </el-tree>
  </div>
</template>

<script>
import iconfont from '@s/assets/iconFont/iconfont.js';
import fileIcon from '../krTable/fileIconControl';

export default {
  props: {
    data: kr.vue.getPropObject(),
    lazy: kr.vue.getPropBoolean(),
    load: kr.vue.getPropFunction()
  },
  data() {
    return {
      fileIcon
    }
  },
  computed: {
    getThreeData() {
      return this.data.tree;
    },
  },
  methods: {
    // loadNode(node, resolve) {
    //   console.log('node', node.level);
    //   console.log('resolve', resolve);
    //   // this.loadNode(node, resolve);
    // },
    handelFile(data) {
      if (this.lazy) {
        this.$emit('input', data);
        return;
      }
      if (data.fileSuffix !== 'folder') {
        this.$emit('input', data);
      } else {
        this.$emit('input', undefined);
      }
    }
  }
}
</script>

<style lang="scss">

  .comp-md-file-tree {
    height: 290px;
    border: 1px solid #e6e9f5;
    border-radius: 2px;
    overflow: auto;

    .icon {
      font-size: 16px;
      width: 1em;
      height: 1em;
      vertical-align: -0.2em;
      fill: currentColor;
      overflow: hidden;
    }
  }

</style>
